// React
import * as React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

// Redux
import { createStore, applyMiddleware } from "redux";
import { connect, Provider } from "react-redux";
import thunk from "redux-thunk";

// Framework
import { getURLByEnv } from "./framework/utils/URL";

// Store
import { MainStore } from "./store/MainStore";

// Views
import Home from "./UI/views/Home";
import Login from "./UI/views/Login";
import Logout from "./UI/views/Logout";

// Components
import Navigation from "./UI/components/Navigation";

/**
 * @description Main file for the App
 * @author Lucas Fridez <lfridez@artionet.com>
 * @class App
 * @extends {Component}
 */
class App extends React.Component {

  /**
   * @description Render the WebApp
   * @author Lucas Fridez <lfridez@artionet.com>
   * @returns
   * @memberof App
   */
  render() {
    return (
      <Provider store={MainStore.getStore()}>
        <Router>
          <div id="webapp">
            <Navigation />
            <Route exact={true} path={`${getURLByEnv()}/`} component={Login} />
            <Route path={`${getURLByEnv()}/logout`} component={Logout} />
            <Route path={`${getURLByEnv()}/home`} component={Home} />
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.tsx